import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
    Modal,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import FontAwesomeIcon from '../../../../components/common/FontAwesomeIcon';
import { getCycles } from '../../../../redux/api/events/events';
import SimpleLoading from '../../../../components/common/SimpleLoading';
import Text from '../../../../components/common/Text';

const ClassEventCyclesModal = ({ onFilterCycle }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [cycles, setCycles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedCycle, setExpandedCycle] = useState(null);

    const handleOpen = () => {
        setIsOpen(true);
        fetchCycles();
    };

    const handleClose = () => {
        setIsOpen(false);
        setExpandedCycle(null);
    };

    const fetchCycles = async () => {
        setLoading(true);
        const response = await getCycles();
        if (response.error) {
            setCycles([]);
        } else {
            setCycles(response || []);
        }
        setLoading(false);
    };

    const handleAccordionChange = (cycleId) => (event, isExpanded) => {
        setExpandedCycle(isExpanded ? cycleId : null);
    };

    const handleFilterCycle = (cycle) => {
        if (onFilterCycle) {
            onFilterCycle(cycle);
        }
        handleClose();
    };

    return (
        <>
            <TriggerButton onClick={handleOpen}>
                <FontAwesomeIcon
                    icon="fa-light fa-book"
                    size={20}
                    color="#b31d15"
                />
                <span>Ver ciclos disponibles</span>
            </TriggerButton>

            <Modal onClose={handleClose} open={isOpen}>
                <Container>
                    <Header>
                        <Text fontSize="1.5rem" fontWeight="600" color="#222">
                            Ciclos disponibles
                        </Text>
                        <CloseButton onClick={handleClose}>
                            <FontAwesomeIcon
                                icon="fa-light fa-close"
                                size={20}
                            />
                        </CloseButton>
                    </Header>

                    <Content>
                        {loading ? (
                            <LoadingWrapper>
                                <SimpleLoading />
                            </LoadingWrapper>
                        ) : cycles.length === 0 ? (
                            <EmptyState>
                                <p>No hay ciclos disponibles</p>
                            </EmptyState>
                        ) : (
                            <CyclesList>
                                {cycles.map((cycle) => (
                                    <CycleAccordion
                                        key={cycle.id}
                                        expanded={expandedCycle === cycle.id}
                                        onChange={handleAccordionChange(
                                            cycle.id
                                        )}
                                    >
                                        <AccordionSummary
                                            expandIcon={
                                                <FontAwesomeIcon
                                                    icon={
                                                        expandedCycle ===
                                                        cycle.id
                                                            ? 'fa-light fa-chevron-up'
                                                            : 'fa-light fa-chevron-down'
                                                    }
                                                    size={16}
                                                    color="#616161"
                                                />
                                            }
                                        >
                                            <CycleName>{cycle.name}</CycleName>
                                            <ViewClassesText>
                                                {expandedCycle === cycle.id
                                                    ? 'Ocultar clases'
                                                    : 'Ver clases'}
                                            </ViewClassesText>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <ClassesList>
                                                {cycle.events &&
                                                cycle.events.length > 0 ? (
                                                    cycle.events.map(
                                                        (event) => (
                                                            <ClassItem
                                                                key={event.id}
                                                            >
                                                                {event.is_online ? (
                                                                    <Text
                                                                        fontSize="0.9rem"
                                                                        fontWeight="500"
                                                                        color="#616161"
                                                                    >
                                                                        CLASE
                                                                        ONLINE
                                                                    </Text>
                                                                ) : (
                                                                    <Text
                                                                        fontSize="0.9rem"
                                                                        fontWeight="500"
                                                                        color="#616161"
                                                                    >
                                                                        CLASE
                                                                        PRESENCIAL
                                                                    </Text>
                                                                )}
                                                                <Text
                                                                    fontSize="0.9rem"
                                                                    fontWeight="500"
                                                                    color="#616161"
                                                                    ellipsis
                                                                >
                                                                    •{' '}
                                                                    {
                                                                        event.publication_name
                                                                    }
                                                                </Text>
                                                            </ClassItem>
                                                        )
                                                    )
                                                ) : (
                                                    <Text
                                                        fontSize="0.9rem"
                                                        fontWeight="500"
                                                        color="#616161"
                                                    >
                                                        No hay clases
                                                        disponibles en este
                                                        ciclo
                                                    </Text>
                                                )}
                                            </ClassesList>
                                            {cycle.events &&
                                                cycle.events.length > 0 && (
                                                    <FilterCycleButton
                                                        onClick={() =>
                                                            handleFilterCycle(
                                                                cycle
                                                            )
                                                        }
                                                    >
                                                        <FontAwesomeIcon
                                                            icon="fa-light fa-bars-filter"
                                                            size={16}
                                                            color="#b31d15"
                                                        />
                                                        <span>
                                                            Filtrar las clases
                                                            de este ciclo
                                                        </span>
                                                    </FilterCycleButton>
                                                )}
                                        </AccordionDetails>
                                    </CycleAccordion>
                                ))}
                            </CyclesList>
                        )}
                    </Content>
                </Container>
            </Modal>
        </>
    );
};

export default ClassEventCyclesModal;

const ModalFake = styled(Modal)``;

const Container = styled.div`
    border: none;
    outline: none;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    width: 70%;
    max-width: 90vw;
    height: 90vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    overflow: hidden;
    @media (max-width: 768px) {
        width: 95vw;
        max-width: 95vw;
        height: 95vh;
    }
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
`;

const CloseButton = styled.button`
    cursor: pointer;
    background: none;
    border: none;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #616161;
    transition: color 0.2s;

    &:hover {
        color: #b31d15;
    }
`;

const Content = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 24px;
`;

const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
`;

const EmptyState = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;

    p {
        color: #616161;
        font-size: 1rem;
    }
`;

const CyclesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const CycleAccordion = styled(Accordion)`
    border-radius: 12px !important;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08) !important;
    border: none !important;
    margin: 0 !important;

    &:before {
        display: none;
    }

    .MuiAccordionSummary-root {
        padding: 2rem 1.5rem;
        min-height: auto;
    }

    .MuiAccordionSummary-content {
        margin: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .MuiAccordionDetails-root {
        padding: 0 20px 20px 20px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
`;

const CycleName = styled.span`
    font-size: 1rem;
    font-weight: 700;
    color: #222;
`;

const ViewClassesText = styled.span`
    font-size: 0.9rem;
    color: #616161;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-right: 1rem;
`;

const ClassesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const ClassItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;
const FilterCycleButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border: 1px solid #b31d15;
    border-radius: 50px;
    background-color: #ffffff;
    color: #b31d15;
    font-size: 0.9rem;
    cursor: pointer;
    align-self: flex-end;
    transition: all 0.2s;

    &:hover {
        background-color: #b31d15;
        color: #ffffff;

        svg {
            color: #ffffff !important;
        }
    }
`;

const TriggerButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border: 1px solid #b31d15;
    border-radius: 50px;
    background-color: #b31d15;
    color: #ffffff;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s;
    svg {
        color: #ffffff !important;
    }
`;
